<section class="section-div">
  <div class="content-details">
    <mat-tab-group>
      <mat-tab label="Incubator Register Approval">
        <div class="p-4">
          <app-incubator-approval></app-incubator-approval>
        </div>
      </mat-tab>
      <mat-tab label="Corporate Register Approval">
        <div class="p-4">
          <app-corporate-approval></app-corporate-approval>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
